import { render, staticRenderFns } from "./DocumentTemplateDetailDownload.vue?vue&type=template&id=181b63e0&"
import script from "./DocumentTemplateDetailDownload.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
